import React, { useEffect } from 'react';
import { actionsBanner, bannerSelector } from '@/reducers/banner/banner.slice';
import { useDispatch, useSelector } from 'react-redux';
import styles from './banner.module.scss';
import { BannerProps } from './banner.types';

const Banner: React.FC<BannerProps> = ({ bannerTag, retailerToken }) => {
  const { img, url } = useSelector(bannerSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actionsBanner.getBannerRequest({ bannerTag, retailerToken }));
  }, [bannerTag, dispatch, retailerToken]);

  return (
    <div className={styles.banner}>
      {url !== '' ? (
        <a href={url} target="_blank" rel="noreferrer">
          <img src={img} alt="" />
        </a>
      ) : (
        <img src={img} alt="" />
      )}
    </div>
  );
};

export default Banner;
